<template>
    <div class="table-head-tools-popup" :class="{show: columnData.showPopup}" v-on-clickaway="closePopup">
        <div v-if="columnData.sortable" class="table-sort">
            <label>{{ $t('global.toSort') }}</label>
            <div class="btns-container">
                <div class="table-head-tools-btn btn-sort-asc" :class="{active: columnData.activeSort === '+'}"
                     v-on:click="setSort(columnData,'+')">
                  <i class="fa fa-sort-alpha-asc" aria-hidden="true"></i>
                </div>
                <div class="table-head-tools-btn btn-sort-desc" :class="{active: columnData.activeSort === '-'}"
                     v-on:click="setSort(columnData,'-')">
                  <i class="fa fa-sort-alpha-desc" aria-hidden="true"></i>
                </div>
                <div class="table-head-tools-btn btn-sort-none" :class="{active: columnData.activeSort === false}"
                     v-on:click="setSort(columnData,false)">
                  <i class="fa fa-undo" aria-hidden="true"></i>
                </div>
            </div>
        </div>
        <div v-if="columnData.filter" class="table-filter">
            <label>{{ $t('global.toFilter') }}</label>
            <input v-if="columnData.filter.type == 'text'" type="text" class="form-input full-width"
                   :class="{active: columnData.activeFilter !== ''}" v-on:keyup="setFilter(columnData,true)"
                   v-model="currentFilter" :placeholder="columnData.filter.label || columnData.label"/>
            <select v-if="columnData.filter.type == 'list'" class="form-input full-width"
                    :class="{active: columnData.activeFilter !== ''}" v-on:change="setFilter(columnData,false)"
                    v-model="currentFilter">
                <option value=""></option>
                <option v-for="valueItem in columnData.filter.values" :key="valueItem.id" :value="valueItem.id"
                        :selected="valueItem.id == columnData.activeFilter ? 'selected' : ''">{{ valueItem.label }}
                </option>
            </select>
            <DatePicker v-if="columnData.filter.type == 'date'" v-model="currentFilter"></DatePicker>
        </div>
    </div>

</template>

<script>
    import {mixin as clickaway} from 'vue-clickaway';
    import debounce from 'lodash/debounce'
    import DatePicker from '@/components/ui/datetime/DatePicker'

    export default {
        name: 'tablefilterpopup',
        props: ['columnData'],
        mixins: [clickaway],
        data: () => ({
            currentFilter: null,
            _columnData: null,
            firstTime: true,
        }),
        components: {
            DatePicker
        },
        methods: {
            setSort: function (column, sort) {
                this.$emit('sort', column, sort)
            },
            setFilter: function (column, debounce) {
                if(debounce){
                    this.debounceEmitFilter(column);
                }
                else{
                    this.$emit('filter', column, this.currentFilter)
                }

            },
            debounceEmitFilter: debounce(function (column) {
                this.$emit('filter', column, this.currentFilter)
            }, 500),
            closePopup: function () {
                if (!this.firstTime) {
                    this.$emit('close', this.columnData)
                } 
            }
        },
        created: function () {
            this._columnData = this.columnData;
            this.currentFilter = this.columnData.activeFilter;
            this.$nextTick(function () {
                this.firstTime = false
            })
        },
    }
</script>

<style lang="scss" scoped>

</style>
